// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2923149e","239":"4b28ee37","453":"8c50dc9d","732":"01b0ccba"}[chunkId] + ".chunk.js";
};